import { FileModel } from '../../file.model';
import { LocalizedValueModel } from '../../localized-value.model';

export class LanguagePresenterModel {
  id: string;
  code: string;
  direction?: 'rtl' | 'ltr';
  flag: string;
  isDefault: boolean;
  mobile_translation_file?: null | FileModel;
  name: LocalizedValueModel;
  web_translation_files?: null | FileModel;
}

export type Icon = {
  name: string;
};
